import type { FireIconProps } from './types';

export default function LadderTruck({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Cab */}
      <path d="M1 14h4V9h3l2-3h4v8" />
      {/* Body */}
      <rect x="14" y="10" width="9" height="4" rx="0.5" />
      {/* Ladder */}
      <line x1="15" y1="11" x2="22" y2="11" />
      <line x1="15" y1="13" x2="22" y2="13" />
      <line x1="16.5" y1="11" x2="16.5" y2="13" />
      <line x1="18.5" y1="11" x2="18.5" y2="13" />
      <line x1="20.5" y1="11" x2="20.5" y2="13" />
      {/* Undercarriage */}
      <line x1="1" y1="14" x2="23" y2="14" />
      {/* Wheels */}
      <circle cx="5" cy="17" r="2" />
      <circle cx="19" cy="17" r="2" />
      {/* Axle line */}
      <line x1="7" y1="15" x2="17" y2="15" />
    </svg>
  );
}
